import { z } from "zod";

export const EntregaObraClienteArquivoAuxSchema = z.object({
    idEntregaObraClienteArquivoAux: z.number().int().optional(),
    idEntregaObraCliente: z.number().int().positive(),
    nome: z.string().optional().nullable(),
    descricao: z.string().optional(),

    arquivo: z.instanceof(File).nullable().default(null),
    limparArquivo: z.boolean().optional().default(false),
});

export type EntregaObraClienteArquivoAuxForm = z.infer<typeof EntregaObraClienteArquivoAuxSchema>;

export const defaultEntregaObraClienteArquivoAuxForm: Partial<EntregaObraClienteArquivoAuxForm> = {
    idEntregaObraClienteArquivoAux: undefined,
    idEntregaObraCliente: undefined,
    nome: undefined,
    descricao: undefined,
    arquivo: null,

    limparArquivo: false,

};
